import { httpClient } from '../httpClient';

export const privacyNoticesApi = {
  listNotices: (params = {}) =>
    httpClient.get('/privacy-notices/', { params }),

  createNotice: (data) =>
    httpClient.post('/privacy-notices/', data),

  getNotice: (id) =>
    httpClient.get(`/privacy-notices/${id}`),

  updateNotice: (id, data) =>
    httpClient.patch(`/privacy-notices/${id}`, data),

  publishNotice: (id) =>
    httpClient.post(`/privacy-notices/${id}/publish`),

  deleteNotice: (id) =>
    httpClient.delete(`/privacy-notices/${id}`),
};
